import { render, staticRenderFns } from "./RevisionLotesSlot.vue?vue&type=template&id=54a97120&scoped=true"
import script from "./RevisionLotesSlot.vue?vue&type=script&lang=js"
export * from "./RevisionLotesSlot.vue?vue&type=script&lang=js"
import style0 from "./RevisionLotesSlot.vue?vue&type=style&index=0&id=54a97120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a97120",
  null
  
)

export default component.exports